import { Injectable } from "@angular/core";
import { AuthService } from "../../app/auth/auth.service";
import { DataModel } from "../../models/notificiations/websocket-message";
import { ConfigurationService } from "../configuration/configuration.service";
import { BaseWebSocketService } from "./base-websocket.service";

@Injectable()
export class AlertWebSocketService extends BaseWebSocketService<DataModel> {
  appSyncDomain: string;
  namespace: string = "alerts-notifications";

  constructor(private config: ConfigurationService, authSvc: AuthService) {
    super(authSvc);
    this.appSyncDomain = this.config.getConfig().appSyncDomain;
  }
}



// WEBPACK FOOTER //
// ./src/providers/appsync/alter-notifications-websocket.service.ts